export default __webpack_public_path__ + "static/5-collapse-game-874f62bd90e4fea843aaeb1f7ffddfe7.jpg";